module.exports = __webpack_public_path__ + "static/media/celular.ddbfa9cb.png";